import { useEffect, useRef, useState } from 'react'

export const useShowMore = () => {
  const [expanded, setExpanded] = useState(false)
  const [overflowActive, setOverflowActive] = useState(false)
  const textRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (checkOverflow(textRef.current)) {
      setOverflowActive(true)
      return
    }

    setOverflowActive(false)
  }, [overflowActive])

  const checkOverflow = (textContainer: HTMLSpanElement | null): boolean => {
    if (textContainer)
      return (
        textContainer.offsetHeight < textContainer.scrollHeight ||
        textContainer.offsetWidth < textContainer.scrollWidth
      )
    return false
  }

  const handleToggle = () => setExpanded(!expanded)

  return {
    expanded,
    handleToggle,
    textRef,
    overflowActive,
  }
}
